import header from "./empty-rooms.jpg";
import section1 from "./floor-plan.webp";
import section2 from "./map-on-tablet.jpg";
import section3 from "./measurement-icons.webp";
import section4 from "./measuring-house.jpg";
import section5 from "./person-measuring-rooms.jpg";
import section6 from "./floor-plan-2.webp";
import section7 from "./measuring-rooms.webp";

export {
  header,
  section1,
  section2,
  section3,
  section4,
  section5,
  section6,
  section7,
};
